import { useAddNativeClasses } from '@carvana/merch-native/hooks';
import { useTrackClickEvents } from '@carvana/merch-react-hooks';
import { useEffect } from 'react';
import {
  useLogZipCodeChanges,
  useNavigation,
  useRemoveQueryParams,
  useScrollToTop,
  useSetCvnaId,
  useSetPageNumber,
  useShowFinance,
  useToggleAppliedTradeCookie
} from '@/Search/hooks';
import { useNativeDeviceType } from '~/contexts/DeviceContext';
import { useTrackEvent } from '~/contexts/SearchAnalyticsContext';
import {
  useGetAvailability,
  useGetFacetData,
  useGetInventory,
  useGetPricing,
  useGetUserProfile
} from '~/hooks/services';
import { useGetLowInventoryAvailability } from '~/hooks/services/useGetAvailability';
import useGetTrades from '~/hooks/services/useGetTrades';
import useModalScrollRestoration from '~/hooks/useModalScrollRestoration';
import useResizeListener from '~/hooks/useResizeListener';
import useSetDataDogContext from '~/hooks/useSetDataDogContext';
import useTrackTilePerformance from '~/hooks/useTrackTilePerformance';
import useTradeToggled from '~/hooks/useTradeToggled';
import { useNativeMessageDispatcher, useNativeMessageListener } from '~/native';
import BrowserCookies from '~/utilities/BrowserCookies';
import { useFilteredByMinDown } from './hooks/conditionalTiles';
import { useTrackResults } from './hooks/events';
import useGetCreditStatus from './hooks/useGetCreditStatus';

function useFullStoryUserVars() {
  useEffect(() => {
    window.FS?.setUserVars({
      browserCookieId: BrowserCookies.get('BrowserCookieId'),
      searchVersion: process.env.APP_VERSION
    });
  }, []);
}

type OwnProps = {
  fetchedInventoryOnServer?: boolean;
};

function SearchData(props: OwnProps) {
  const nativeDeviceType = useNativeDeviceType();
  const trackEvent = useTrackEvent();

  useRemoveQueryParams();
  useGetCreditStatus();
  useGetTrades();
  useTradeToggled();
  useResizeListener();
  useFullStoryUserVars();
  useTrackTilePerformance();
  useGetFacetData();
  useGetInventory(props.fetchedInventoryOnServer);
  useGetAvailability();
  useGetPricing();
  useGetUserProfile();
  useNavigation();
  useScrollToTop();
  useSetCvnaId();
  useSetPageNumber();
  useShowFinance();
  useToggleAppliedTradeCookie();
  useTrackClickEvents(trackEvent);
  useTrackResults();
  useSetDataDogContext();
  useGetLowInventoryAvailability();
  useLogZipCodeChanges();
  useFilteredByMinDown();
  useNativeMessageDispatcher();
  useNativeMessageListener();
  useAddNativeClasses(nativeDeviceType.isNative, nativeDeviceType.platform);
  useModalScrollRestoration();

  return null;
}

export default SearchData;
